import { CSSProperties } from 'react'

export const commonSteamLogoStyles: CSSProperties = {
  position: 'absolute',
  top: '30px',
  left: '30px',
  width: '14px',
  height: '14px',
  zIndex: 2,
}
